import { config } from '../../Config';


async function retryOperation(fn, retries, delay) {
    try {
      return await fn();
    } catch (error) {
      if (retries <= 0) {
        throw error;
      }
      console.warn(`Operation failed. Retrying in ${delay}ms... (${retries} retries left)`);
      await new Promise(resolve => setTimeout(resolve, delay));
      // Recursively retry with a doubled delay.
      return retryOperation(fn, retries - 1, delay * 2);
    }
  }
  
  const DeleteFiles = async (
    chatId = "default",
    documentId = "default",
    { retries = 3, delay = 1000 } = {}
  ) => {
    const url = config.deleteFile;
  
    const operation = async () => {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chatId, documentId }),
      });
      if (!response.ok) {
        throw new Error(`Failed to delete files: ${response.statusText}`);
      }
      return true;
    };
  
    return retryOperation(operation, retries, delay);
  };
  
  export default DeleteFiles;
  

